module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Joanna Challis\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("JOANNA CHALLIS lives and writes in Australia.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/XciiUo/tc-custom/9781429988674.jpg?1722310221883",
      "alt": "This image is the cover for the book Murder on the Cliffs, Daphne du Maurier Mysteries"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Murder on the Cliffs, Daphne du Maurier Mysteries\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('i', [_vm._v("The storm led me to Padthaway. "), _c('br'), _c('br'), _vm._v("I could never resist the allure of dark swirling clouds, windswept leaves sweeping down cobbled lanes or a view of the sea stirring up its defiant nature. The sea possessed a power all of its own and this part of Cornwall, an isolated stretch of rocky cliff tops and unexplored beaches both enchanted and terrified me. "), _c('br'), _c('br'), _vm._v("It is not a lie to say I felt drawn out that day, led to a certain destiny... "), _c('br'), _c('br')]), _vm._v("So begins this new mystery series featuring young Daphne du Maurier, headstrong, adventurous, and standing at the cusp of greatness. "), _c('br'), _c('br'), _vm._v("Walking on the cliffs in Cornwall, she stumbles upon the drowned body of a beautiful woman, dressed only in a nightgown, her hair strewn along the rocks, her eyes gazing up to the heavens. Daphne soon learns that the mysterious woman was engaged to marry Lord Hartley of Padthaway, an Elizabethan mansion full of intriguing secrets. "), _c('br'), _c('br'), _vm._v("As the daughter of the famous Sir Gerald du Maurier, Daphne is welcomed into the Hartley home, but when the drowning turns out to be murder, Daphne determines to get to the bottom of the mysteries of Padthaway—in part to find fresh inspiration for her writing, and in part because she cannot resist the allure of grand houses and long buried secrets.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    St. Martin’s Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0